<template>
  <div class="event-likes">
    <div class="event-likes-header flex">
      <div v-bind:class="'event-color-'+event.color" class="event-likes-left grow">
        <div class="event-likes-title">{{ event.name }}</div>
        <div class="event-likes-subtitle">{{ interestedPeopleString }}</div>
      </div>
      <div v-on:tap="$emit('close')" class="event-likes-right">
        <img src="../assets/images/life_close_v1.svg" />
      </div>
    </div>
    <div class="event-likes-body">
      <ul>
        <li class="users-list" v-for="user in users" v-bind:key="user.id">
          <div
            class="user-photo"
            v-bind:class="{google : user.photos[0].indexOf('googleusercontent')!==-1}"
          >
            <img class="profilo" v-bind:src="user.photos[0]" />
          </div>
          <span class="grow">{{user.name}}</span>
          <div>
            <i class="rds-icon rds-icon-stella"></i>
          </div>
        </li>
        <!-- <li class="users-list" v-for="user in users" v-bind:key="user.id">
          <div
            class="user-photo"
            v-bind:class="{google : user.photos[0].indexOf('googleusercontent')!==-1}"
          >
            <img class="profilo" v-bind:src="user.photos[0]" />
          </div>
          <span class="grow">{{user.name}}</span>
          <div>
            <i class="rds-icon rds-icon-stella"></i>
          </div>
        </li>
        <li class="users-list" v-for="user in users" v-bind:key="user.id">
          <div
            class="user-photo"
            v-bind:class="{google : user.photos[0].indexOf('googleusercontent')!==-1}"
          >
            <img class="profilo" v-bind:src="user.photos[0]" />
          </div>
          <span class="grow">{{user.name}}</span>
          <div>
            <i class="rds-icon rds-icon-stella"></i>
          </div>
        </li>
        <li class="users-list" v-for="user in users" v-bind:key="user.id">
          <div
            class="user-photo"
            v-bind:class="{google : user.photos[0].indexOf('googleusercontent')!==-1}"
          >
            <img class="profilo" v-bind:src="user.photos[0]" />
          </div>
          <span class="grow">{{user.name}}</span>
          <div>
            <i class="rds-icon rds-icon-stella"></i>
          </div>
        </li>-->
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EventLike',
  props: ['event', 'users'],
  computed: {
    interestedPeopleString() {
      const count = this.event.likes.length;
      let interestedPeople = '';
      if (count === 0) {
        interestedPeople = 'Dì che ti piace prima di tutti';
      } else if (count === 1) {
        interestedPeople = '1 persona interessata';
      } else {
        interestedPeople = `${count} persone interessate`;
      }
      return interestedPeople;
    }
  }
};
</script>
<style lang="scss" scoped>
.event-likes {
  background-color: #ffffff;
  padding: 21px 21px 0px 21px;
  margin: 19px;
  max-height: calc(100% - (19px * 2) - (#{$default-padding} * 2));
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .event-likes-left {
    @each $label, $color in $calendar-colors {
      &.event-color-#{$label} .event-likes-title {
        color: $color;
      }
    }
  }
  .event-likes-header {
    padding-bottom: 19px;
    @include dotted-bottom;
  }
  .event-likes-title {
    //color: #00868c;
    margin: 0 0 7px;
  }
  .event-likes-subtitle {
    color: #607d8b;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .event-likes-right {
    color: rgba(96, 125, 139, 0.5);
    display: flex;
    padding: 15px;
    margin: -24px -15px -15px;
  }
  .users-list {
    display: flex;
    align-content: center;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid rgba(180, 192, 199, 0.29);
    span {
      margin: 0 18px;
    }
  }
  .user-photo {
    width: 38px;
    max-width: none;
    overflow: hidden;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    img {
      height: 38px;
      max-width: none;
      position: relative;
      right: 50%;
    }
  }
  .google.user-photo {
    img {
      border-radius: 50%;
      width: 100%;
      position: inherit;
    }
  }
}
</style>
